var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "section-invert reverse-sm",
      attrs: { id: "medic-assistance" }
    },
    [
      _c(
        "b-col",
        {
          staticClass: "content my-auto ptop",
          attrs: { md: "12", lg: "6", "order-lg": "2" }
        },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("medical-assistance.title")))]),
          _vm._v(" "),
          _c("p", { staticClass: "text-info" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("medical-assistance.subtitle")) +
                "\n      "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("medical-assistance.content")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _c("div", { staticClass: "subtitle-list subtitle-list" }, [
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", { attrs: { large: "" } }, [
                      _vm._v("mdi-video-plus-outline")
                    ]),
                    _vm._v(
                      _vm._s(_vm.$t("medical-assistance.video")) +
                        "\n          "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: {
                        textContent: _vm._s("mdi-cellphone-information")
                      }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("medical-assistance.phone-attention")) +
                        "\n          "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: {
                        textContent: _vm._s(
                          "mdi-file-document-multiple-outline"
                        )
                      }
                    }),
                    _vm._v(
                      _vm._s(
                        _vm.$t("medical-assistance.written-consultation")
                      ) + "\n          "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: {
                        textContent: _vm._s("mdi-comment-processing-outline")
                      }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("medical-assistance.chat")) + "\n          "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: { textContent: _vm._s("mdi-note-plus-outline") }
                    }),
                    _vm._v(
                      _vm._s(
                        _vm.$t("medical-assistance.electronic-prescription")
                      ) + "\n          "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "text-info" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("medical-assistance.safe-coms")) +
                            "\n              "
                        ),
                        _c("div", { staticClass: "logorec" }, [
                          _c("img", {
                            attrs: {
                              src:
                                "/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso-27001.svg",
                              height: "150px"
                            }
                          })
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("b-col", { staticClass: "nopadding", attrs: { md: "12", lg: "6" } }, [
        _c("div", { staticClass: "col-bg ml-lg-auto" })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-de2b0b58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de2b0b58","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/MedicalAssistanceLanding.vue
// module id = 4184
// module chunks = 44